import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useAuth} from '@/contexts/AuthContext';
import {ReitService as reitService} from '@/services/investments';
import {CreateReitHoldingDto} from "@/@types/reit.dto";

/**
 * A custom hook that provides a mutation for creating a REIT holding
 * associated with the authenticated user. It automatically invalidates
 * the REIT holdings query cache upon successful creation.
 *
 * @return {UseMutationResult} The mutation object returned by `useMutation`,
 * allowing you to trigger the creation and manage its state.
 */
export default function useCreateReitHolding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (holding: CreateReitHoldingDto) => {
      return await reitService.createHolding(user!.id, { ...holding, user_id: user.id });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['reit_holdings'] }),
  });
}
